import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Route, RouterModule } from '@angular/router';
import { BillerSharedModule } from './shared/biller-shared.module';
import {CategoryProviderComponent} from './category-provider/category-provider.component';
import { PublicSharedModule } from 'src/app/public-website/public-shared/public-shared.module';
import { SharedModule } from 'src/app/shared/shared.module';
const billSellerRoutes:Route[]=[
  {
    path: '',
    loadChildren: () => import('./biller-home-page/biller-home-page.module').then( m => m.BillerHomePageModule)
  },
  {
    path: 'category/:categoryId',
    component:CategoryProviderComponent,
    loadChildren: () => import('./category-provider/category-providers.module').then( m => m.CategoryProvidersModule)
  },
  {
    path:'balance-pay',
    loadChildren:() => import('./balance-pay/balance-pay.module').then(m=>m.BalancePayModule)
  },
  {
    path: 'credit-card',
    loadChildren: () => import('./credit-card-pay/credit-card-pay.module').then( m => m.CreditCardPayModule)
  },
]

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    RouterModule.forChild(billSellerRoutes),
    BillerSharedModule,
    PublicSharedModule,
    SharedModule,
  ]
})
export class BillerModule { }
